import { useQuery } from "@tanstack/react-query";
import { useApi } from "hooks/useApi";
import { useProduct } from "contexts/ProductContext";

export const useAcpFeedPreview = () => {
  const api = useApi();
  const { product } = useProduct();
  const productId = product?.id;

  return useQuery({
    queryKey: ["product-acp-feed-preview", productId],
    queryFn: () => api.products.getProductAcpFeedPreview(productId!),
    enabled: !!productId,
  });
};
